import type { RoleBatchListItemVO, UserRoleVO } from "@/api/system/roles/type";

import type { ResolvedRoleTerminal } from "./types";

/**
 * 规范化角色名：去掉「模板」后缀便于匹配
 * @param name 原始角色名
 */
export const normalizeRoleName = (name: string): string => name.replace(/模板$/, "").trim();

/**
 * 批量查询角色项转为各端绑定结构
 * @param item 批量角色列表项
 * @param extra 合并绑定上下文（orgType 等）
 */
export const toResolvedTerminalFromBatchItem = (
  item: RoleBatchListItemVO,
  extra?: Partial<ResolvedRoleTerminal>,
): ResolvedRoleTerminal => ({
  roleId: item.id,
  systemTypeId: item.systemTypeId,
  systemTypeCode: item.systemTypeCode,
  systemTypeName: item.systemTypeName,
  orgId: item.orgId,
  templateType: item.templateType as ResolvedRoleTerminal["templateType"],
  roleType: item.roleType,
  permissionCount: item.permissionCount,
  ...extra,
});

/**
 * 将账号角色分组项转为各端绑定列表
 * @param group 账号已绑角色分组
 */
export const toResolvedTerminalsFromUserGroup = (group: UserRoleVO): ResolvedRoleTerminal[] =>
  (group.userRoleInfoList ?? []).map((item) => ({
    roleId: item.roleId,
    systemTypeId: item.systemTypeId,
    systemTypeCode: item.systemTypeCode,
    systemTypeName: item.systemTypeName,
    orgId: item.orgId ?? group.orgId,
    templateType: item.templateType ?? group.templateType,
    roleType: item.roleType ?? group.roleType,
  }));
